import { TUTORIAL_CHAPTERS } from '@il-colpo/engine';
import type { SoloSetup } from '../gameStore.ts';

/** The game a Tutorial chapter starts: the chapter's own table, role, seed and plan. */
export function tutorialSetup(
  chapter: 1 | 2 | 3 | 4 | 5,
  humanName: string,
  language: 'it' | 'en',
): SoloSetup {
  const c = TUTORIAL_CHAPTERS[chapter - 1];
  if (!c) throw new Error(`no tutorial chapter ${chapter}`);
  return {
    mode: 'tutorial',
    players: c.players,
    mapId: 'bank',
    difficulty: 'easy',
    infiltrator: 'never',
    role: c.role,
    botLevel: 'easy',
    humanName,
    language,
    chapter,
  };
}
